<div class="slice-border"></div>
<span class="label">{{ sidebarItem?.label }}</span>
<span class="fa-solid fa-angle-right"></span>
